import type { ApplicantCreation } from 'cpool-schemas';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AddExpense } from './AddExpense';
import { ExpenseItem } from './ExpenseItem';
import { useApplicantAttribution } from '../../util/hooks/useApplicantAttribution';
import { getExpenseDefaultValues } from '../../util/values/expenses';
import {
    expenseListOrder,
    type ExpenseType,
} from '~/features/leadDetails/components/Overview/CustomerData/Expenses/expenseTypeConfig.ts';
import { SectionHeading } from '~/features/leadDetails/components/Overview/CustomerData/shared/SectionHeading.tsx';

export const Expenses: React.FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext<ApplicantCreation>();
    const attribution = useApplicantAttribution();

    const sonstigeAusgaben = useFieldArray({ control, name: 'ausgaben.sonstigeAusgaben' });
    const unterhaltsverpflichtungen = useFieldArray({ control, name: 'ausgaben.unterhaltsverpflichtungen' });
    const mietausgaben = useFieldArray({ control, name: 'ausgaben.mietausgaben' });
    const privateKrankenversicherungen = useFieldArray({ control, name: 'ausgaben.privateKrankenversicherungen' });

    const fieldArrays = {
        mietausgaben,
        privateKrankenversicherungen,
        sonstigeAusgaben,
        unterhaltsverpflichtungen,
    };

    const addExpense = (type: ExpenseType) => {
        fieldArrays[type].append(getExpenseDefaultValues(attribution));
    };

    return (
        <section className="space-b-2 rounded bg-white pb-4">
            <SectionHeading action={<AddExpense onAdd={addExpense} />}>{t('EXPENSES.HEADING')}</SectionHeading>
            <div className="flex flex-col gap-2">
                {expenseListOrder.flatMap((type) =>
                    fieldArrays[type].fields.map((field, index) => (
                        <ExpenseItem
                            key={field.id}
                            index={index}
                            type={type}
                            onRemove={() => fieldArrays[type].remove(index)}
                        />
                    )),
                )}
            </div>
        </section>
    );
};
